"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

export default function Hero() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className="px-4 sm:px-6 md:px-[2%] pt-[15px] sm:pt-[18px] md:pt-[env(safe-area-inset-top)] mb-[clamp(16px,2.5vh,32px)] md:mb-[clamp(20px,2.5vh,40px)]">
      <div className="relative overflow-hidden rounded-2xl md:rounded-[20px] bg-black shadow-lg">
        {/* Background image */}
        <div className="relative h-[80vh] sm:h-[85vh] md:h-[90vh] w-full">
          <Image
            src="/homepage/banner.png"
            alt="Michigan Manufacturing International - Precision manufacturing facility"
            fill
            priority
            className="object-cover object-center"
            sizes="100vw"
          />
        </div>

        {/* Overlay gradient */}
        <div
          className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"
          aria-hidden="true"
        />

        {/* Text content */}
        <div className="absolute bottom-0 left-0 right-0 flex flex-col items-center justify-end text-center px-4 sm:px-6 pb-10 sm:pb-12">
          {/* BIG responsive heading */}
          <h1
            className={`text-white tracking-tight leading-[1.05] whitespace-normal md:whitespace-nowrap
              text-[clamp(20px,5.5vw,72px)]
              transition-all duration-700 ${
                shown ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
              }`}
          >
            Designed,&nbsp;Manufactured,&nbsp;Delivered
          </h1>

          {/* Subtitle */}
          <p
            className={`mt-2 text-white/90 leading-[1.6] max-w-[36ch]
              text-[clamp(14px,1.6vw,20px)]
              transition-all duration-700 delay-75 ${
                shown ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
              }`}
          >
            A Legacy of Quality and Innovation
          </p>

          {/* CTA */}
          <Link
            href="/contact"
            className={`mt-5 inline-flex items-center justify-center rounded-[30px] bg-[#FDC300]
              px-[26px] py-[12px]
              text-[clamp(14px,1.2vw,16px)] font-semibold text-black
              shadow-sm hover:brightness-95 transition-all ${
                shown ? "opacity-100" : "opacity-0"
              }`}
          >
            Get in touch
          </Link>
        </div>
      </div>
    </header>
  );
}
